import { Component, ChangeDetectionStrategy } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToasterService } from "@shared/services/toaster.service";
import { LogService } from "@shared/services/log.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { AdminHookshotGithubApiService } from "@shared/services/admin/admin-hookshot-github-api.service";
import { FormsModule } from "@angular/forms";

export interface ManageSelfhostedHookshotGithubBridgeDialogContext {
    provisionUrl: string;
    sharedSecret: string;
    bridgeId: number;
    isAdding: boolean;
}

@Component({
    selector: "my-hookshot-github-bridge-manage-selfhosted",
    templateUrl: "./manage-selfhosted.component.html",
    styleUrls: ["./manage-selfhosted.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, TranslatePipe]
})
export class AdminHookshotGithubBridgeManageSelfhostedComponent {

    isSaving = false;
    provisionUrl: string;
    sharedSecret: string;
    bridgeId: number;
    isAdding = true;

    constructor(
        public modal: NgbActiveModal,
        private readonly hookshotApi: AdminHookshotGithubApiService,
        private readonly toaster: ToasterService,
        public translate: TranslateService,
        private readonly logService: LogService,
    ) {
        this.translate = translate;
    }

    public add() {
        this.isSaving = true;
        if (this.isAdding) {
            this.hookshotApi.newSelfhosted(this.provisionUrl, this.sharedSecret).then(() => {
                this.translate.get('Github bridge added').subscribe((res: string) => {
                    this.toaster.pop("success", res);
                });
                this.modal.close();
            }).catch(err => {
                this.logService.error(err);
                this.isSaving = false;
                this.translate.get('Failed to create Github bridge').subscribe((res: string) => {
                    this.toaster.pop("error", res);
                });
            });
        } else {
            this.hookshotApi.updateSelfhosted(this.bridgeId, this.provisionUrl, this.sharedSecret).then(() => {
                this.translate.get('Github bridge updated').subscribe((res: string) => {
                    this.toaster.pop("success", res);
                });
                this.modal.close();
            }).catch(err => {
                this.logService.error(err);
                this.isSaving = false;
                this.translate.get('Failed to update Github bridge').subscribe((res: string) => {
                    this.toaster.pop("error", res);
                });
            });
        }
    }
}
